import api, { fetchCsrfToken } from './api';
import { User } from '@/types';

const login = async (email: string, password: string, redirect?: string): Promise<{ user: User; token: string; message: string; redirect_to?: string }> => {
  try {
    await fetchCsrfToken();
    // include redirect if provided; backend will sanitize and may return redirect_to
    const response = await api.post('/api/auth/login', { email, password, redirect });
    return {
      user: response.data.user, // Directly use the camelCase user object
      token: response.data.token || response.data.accessToken,
      message: response.data.message || 'Login successful',
      redirect_to: response.data.redirect_to,
    };
  } catch (error: any) { 
    throw new Error(error?.response?.data?.message || 'Login failed');
  }
};

const register = async (data: {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  passwordConfirmation: string;
}): Promise<{ user: User; token: string; message: string }> => {
  try {
    await fetchCsrfToken();
    const response = await api.post('/api/auth/register', data);
    return {
      user: response.data.user, // Directly use the camelCase user object
      token: response.data.token || response.data.accessToken,
      message: response.data.message || 'Registration successful',
    };
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Registration failed');
  }
};

const getCurrentUser = async (): Promise<User> => {
  try {
    const response = await api.get('/api/auth/user');
    return response.data.user; // Directly use the camelCase user object
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to fetch user');
  }
};

const logout = async (): Promise<{ message: string }> => {
  try {
    await api.post('/api/auth/logout');
    return { message: 'Logged out successfully' };
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Logout failed');
  }
};

export const authApi = {
  login,
  register,
  getCurrentUser,
  logout,
};